import { View, Flex, Link } from '@adobe/react-spectrum';
import { ComponentFactory } from '../../../../components/protected/layout-components/ComponentFactory';
import { FinderIcon } from '../../../../components/protected/Icons/IconsLib';
import type { FPAData } from '../../../../infra/protected/FPA/FPAData';
import type { SystemAttributes } from '../../../../infra/protected/Layout/SystemAttributes';
import type { ProjectItem } from '../types';
import { Loader } from './Loader';
import styles from '../project_activities.module.css';
import { LayoutDefinition } from '../../../../infra/protected/Layout/LayoutDefinitions';

export interface MobileDetailViewProps {
  selectedItem: FPAData | null;
  selectedDataRow: ProjectItem | Record<string, never>;
  definition: LayoutDefinition | null;
  showLoader: boolean;
  onClose: () => void;
  onOpenFinder: () => void;
  systemAttributes: SystemAttributes<FPAData>;
  addStatusColor: (statusName: string) => string | undefined;
}

export function MobileDetailView({
  selectedItem,
  selectedDataRow,
  definition,
  showLoader,
  onClose,
  onOpenFinder,
  systemAttributes,
  addStatusColor,
}: MobileDetailViewProps) {
  return (
    <>
      <View position="relative" width="100%" height="64px" overflow="hidden" UNSAFE_className={styles.layout_header_parent}>
        <View position="absolute" top="calc(50% - 14px)" left="15%" UNSAFE_className={styles.layout_header_text}>
          {selectedItem?.item_type_name}
        </View>
        <View position="absolute" top="calc(50% - 15px)" left="25px" width="24px" height="30px" overflow="hidden" UNSAFE_className={styles.layout_header_btn_back}>
          <Link onPress={onClose}>
            <i className="bi bi-chevron-left fs-5" />
          </Link>
        </View>
        <View position="absolute" top="calc(50% - 15px)" right="25px" width="24px" height="30px" overflow="hidden">
          <Link onPress={onOpenFinder} UNSAFE_className={styles.layout_header_btn_folder}>
            <FinderIcon size={24} />
          </Link>
        </View>
      </View>
      <Flex direction="column" alignItems="center" justifyContent="center" UNSAFE_className={styles.detailsHolder} UNSAFE_style={{ padding: '20px', paddingTop: '0px' }}>
        {selectedItem && (
          <>
            {showLoader ? (
              <Loader />
            ) : (
              <>
                <View
                  UNSAFE_className={styles.service_status_bar}
                  marginBottom="5px"
                  marginTop="0px"
                  UNSAFE_style={{
                    backgroundColor: addStatusColor(
                      (selectedDataRow as ProjectItem).customStateName ?? ''
                    ),
                  }}
                />
                <ComponentFactory
                  key={(selectedDataRow as ProjectItem).id}
                  selectedItem={selectedItem}
                  definition={definition}
                  systemAttributes={systemAttributes}
                />
              </>
            )}
          </>
        )}
      </Flex>
    </>
  );
}
